export default "__VITE_ASSET__CYLQ8RVl__"